import { cn, createBEM } from "@/libs";
import "./index.scss";
import { AmountWithIcon } from "@/components/AmountWithIcon";

export const CurrentVB = ({value}: {value:string}) => {
  const b = createBEM('i-currentvb');
  return  <div className={cn(b())}>
    转入金额: <span className={cn(b('text'))}><AmountWithIcon amount={value || '0'}/></span>
  </div> 
}